import { acceptHMRUpdate, defineStore } from "pinia";


export const useDebugStore = defineStore("debugStore", {
    state: () => ({
        services: {
            redis: {
                enabled: false,
                host: ''
            },
            dataDogBrowserLogs: {
                enabled: false,
                clientToken: null
            },
            dataDogBrowserRum: {
                enabled: false,
                clientToken: null
            },
            bazaarvoice: {
                enabled: false,
                siteId: null
            },
            algolia: {
                enabled: false,
                applicationId: null
            }
        },

    }),
    actions: {

    },

});

// Pinia hot reload
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useDebugStore, import.meta.hot));
}
